var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0C962B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7786 11.2974C6.88147 11.3553 6.99414 11.3833 7.10607 11.3833C7.2916 11.3833 7.47454 11.3059 7.60474 11.1591C8.815 9.79382 9.88014 8.26588 10.7701 6.61742L10.9322 6.31728C11.1073 5.99342 10.9863 5.58908 10.6627 5.41395C10.3378 5.23948 9.93347 5.35988 9.759 5.68382L9.597 5.98395C8.85027 7.36675 7.9746 8.65875 6.98827 9.83255C6.54947 9.47675 6.18687 8.99888 5.94207 8.44648C5.7936 8.10988 5.39973 7.95595 5.06253 8.10728C4.72593 8.25635 4.57427 8.64995 4.72333 8.98682C5.16207 9.97708 5.89187 10.7977 6.7786 11.2974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.fdf18e9e9347c22fa25bbd8b4906dab4.svg";
export { ForwardRef as ReactComponent };